<!-- Presentation Name -->
<stretchy-input
  class="presentation-name tw-min-w-0 tw-flex-shrink"
  [(value)]="templateEditorFactory.presentation.name"
  ariaLabel="Edit presentation name"
/>
<div
  class="btn-group template-editor-toolbar__desktop-more-menu template-editor-toolbar__desktop-more-menu--title"
  dropdown
>
  <button
    id="moreSettingsButton"
    type="button"
    class="dropdown-toggle tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-gray-200 tw-bg-transparent tw-p-0 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
    [matMenuTriggerFor]="desktopMoreMenu"
    aria-label="Presentation options"
  >
    <mat-icon
      svgIcon="more-horizontal"
      class="template-editor-toolbar__more-icon"
    />
  </button>
  <mat-menu
    #desktopMoreMenu="matMenu"
    id="moreMenu"
    role="menu"
    tabindex="-1"
    aria-labelledby="moreSettingsButton"
  >
    <ng-template matMenuContent>
      <ng-container *ngTemplateOutlet="presentationOptionsMenu"></ng-container>
    </ng-template>
  </mat-menu>
</div>
<div
  class="template-editor-toolbar__mobile-actions tw-flex tw-flex-row tw-items-center"
>
  <presentation-orientation-selector
    class="template-editor-toolbar__mobile-orientation"
  ></presentation-orientation-selector>
  <div
    class="history-controls-wrapper template-editor-toolbar__mobile-history"
    *requireRole="'sa'"
  >
    <div
      *ngIf="templateEditorFactory.isInlineEditing"
      class="inline-edit-shield"
    ></div>
    <button
      id="undoButtonMobile"
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-rounded-[6px] tw-p-[10px] tw-bg-transparent tw-border-0"
      [disabled]="
        !templateEditorFactory.canUndo() ||
        templateEditorFactory.isInlineEditing
      "
      (click)="templateEditorFactory.undo()"
      aria-label="Undo"
      matTooltip="Undo (⌘) + Z"
      [matTooltipDisabled]="!templateEditorFactory.canUndo()"
      matTooltipClass="menu-tooltip"
      matTooltipPosition="below"
    >
      <mat-icon svgIcon="undo" class="medium" />
    </button>
    <button
      id="redoButtonMobile"
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-rounded-[6px] tw-p-[10px] tw-bg-transparent tw-border-0"
      [disabled]="
        !templateEditorFactory.canRedo() ||
        templateEditorFactory.isInlineEditing
      "
      (click)="templateEditorFactory.redo()"
      aria-label="Redo"
      matTooltip="Redo (⌘) + Shift + Z"
      [matTooltipDisabled]="!templateEditorFactory.canRedo()"
      matTooltipClass="menu-tooltip"
      matTooltipPosition="below"
    >
      <mat-icon svgIcon="redo" class="medium" />
    </button>
  </div>
  @if (
    templateEditorFactory.hasContentPublisherRole() ||
    templateEditorFactory.hasTeacherRole()
  ) {
    <button
      tabindex="0"
      id="publishButtonMobile"
      class="btn btn-primary visible-xs-inline-block tw-self-center tw-rounded-xl"
      [disabled]="templateEditorFactory.isPublishDisabled()"
      (click)="templateEditorFactory.publish()"
    >
      <mat-icon
        svgIcon="circle-check"
        aria-hidden="true"
        class="publish-button__icon tw-h-[18px] tw-w-[18px] tw-flex-none"
      ></mat-icon>
      <span class="publish-button__label">Publish</span>
    </button>
  }
  <div class="btn-group template-editor-toolbar__more-menu" dropdown>
    <button
      id="moreSettingsButtonMobile"
      type="button"
      class="dropdown-toggle tw-ml-5 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-gray-200 tw-bg-transparent tw-p-0 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
      [matMenuTriggerFor]="mobileMoreMenu"
      aria-label="Presentation options"
    >
      <mat-icon
        svgIcon="more-horizontal"
        class="template-editor-toolbar__more-icon"
      />
    </button>
    <mat-menu
      #mobileMoreMenu="matMenu"
      id="mobileMoreMenu"
      role="menu"
      tabindex="-1"
      aria-labelledby="moreSettingsButtonMobile"
    >
      <ng-template matMenuContent>
        <ng-container
          *ngTemplateOutlet="presentationOptionsMenu"
        ></ng-container>
      </ng-template>
    </mat-menu>
  </div>
</div>
<div class="flex-row ml-auto hidden-xs tw-items-center">
  <presentation-orientation-selector></presentation-orientation-selector>
  <div class="history-controls-wrapper">
    <div
      *ngIf="templateEditorFactory.isInlineEditing"
      class="inline-edit-shield"
    ></div>
    <button
      id="undoButton"
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-rounded-[6px] tw-p-[10px] tw-bg-transparent tw-border-0"
      [disabled]="
        !templateEditorFactory.canUndo() ||
        templateEditorFactory.isInlineEditing
      "
      (click)="templateEditorFactory.undo()"
      aria-label="Undo"
      matTooltip="Undo (⌘) + Z"
      [matTooltipDisabled]="!templateEditorFactory.canUndo()"
      matTooltipClass="menu-tooltip"
      matTooltipPosition="below"
    >
      <mat-icon svgIcon="undo" class="medium" />
    </button>
    <button
      id="redoButton"
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-rounded-[6px] tw-p-[10px] tw-bg-transparent tw-border-0"
      [disabled]="
        !templateEditorFactory.canRedo() ||
        templateEditorFactory.isInlineEditing
      "
      (click)="templateEditorFactory.redo()"
      aria-label="Redo"
      matTooltip="Redo (⌘) + Shift + Z"
      [matTooltipDisabled]="!templateEditorFactory.canRedo()"
      matTooltipClass="menu-tooltip"
      matTooltipPosition="below"
    >
      <mat-icon svgIcon="redo" class="medium" />
    </button>
  </div>
  @if (templateEditorFactory.hasOnlyContentEditorRole()) {
    <button
      mat-flat-button
      id="sendForReviewButton"
      color="primary"
      (click)="templateEditorFactory.openReviewRequest()"
      [class.look-disabled]="!isPublicationApprovalAvailable"
      [disabled]="templateEditorFactory.presentation.revisionStatus === 0"
    >
      Send for Review
      @if (!isPublicationApprovalAvailable) {
        <mat-icon class="small" svgIcon="requires-upgrade"></mat-icon>
      }
    </button>
  } @else if (
    templateEditorFactory.hasContentPublisherRole() ||
    templateEditorFactory.hasTeacherRole()
  ) {
    <!-- Pending review status -->
    @if (
      templateEditorFactory.hasContentPublisherRole() &&
      templateEditorFactory.presentation.revisionStatus === 2
    ) {
      <button
        matButton="outlined"
        id="requestChangesButton"
        class="tw-mr-[8px]"
        (click)="templateEditorFactory.openRequestChanges()"
      >
        Request Changes
      </button>
      @if (!isPublicationApprovalAvailable) {
        <mat-icon class="small" svgIcon="requires-upgrade"></mat-icon>
      }
    }
    <button
      tabindex="0"
      id="publishButtonDesktop"
      class="btn btn-primary publish-button tw-inline-flex tw-h-16 tw-min-h-10 tw-w-auto tw-items-center tw-justify-center tw-gap-4 tw-rounded-lg tw-px-8 tw-text-[14px] tw-font-bold tw-leading-none"
      [disabled]="templateEditorFactory.isPublishDisabled()"
      (click)="templateEditorFactory.publish()"
    >
      <span
        class="tw-flex tw-h-[18px] tw-w-[18px] tw-flex-none tw-items-center tw-justify-center"
        [shown]="
          !templateEditorFactory.savingPresentation &&
          templateEditorFactory.isUnsaved()
        "
      >
        <ng-container
          *ngTemplateOutlet="
            publishChangeState;
            context: { icon: 'alert-circle', tooltip: 'Unsaved changes' }
          "
        ></ng-container>
      </span>
      <span
        class="tw-flex tw-h-[18px] tw-w-[18px] tw-flex-none tw-items-center tw-justify-center"
        [shown]="
          !templateEditorFactory.savingPresentation &&
          !templateEditorFactory.isUnsaved()
        "
      >
        <ng-container
          *ngTemplateOutlet="
            publishChangeState;
            context: { icon: 'circle-check', tooltip: getSavedTooltipText() }
          "
        ></ng-container>
      </span>
      <span
        class="tw-flex tw-h-[18px] tw-w-[18px] tw-flex-none tw-items-center tw-justify-center"
        [shown]="templateEditorFactory.savingPresentation"
      >
        <ng-container
          *ngTemplateOutlet="
            publishChangeState;
            context: { icon: 'refresh', tooltip: 'Saving changes...' }
          "
        ></ng-container>
      </span>
      <span class="publish-button__label tw-leading-none">Publish</span>
    </button>
  }
</div>

<ng-template #presentationOptionsMenu>
  <button
    mat-menu-item
    role="menuitem"
    tabindex="-1"
    id="changeTemplateButton"
    (click)="newPresentation()"
  >
    <mat-icon
      aria-hidden="true"
      class="template-editor-toolbar__menu-icon"
      svgIcon="add"
    ></mat-icon>
    <span>New presentation</span>
  </button>
  <button
    mat-menu-item
    role="menuitem"
    tabindex="-1"
    id="copyPresentationButton"
    [disabled]="!templateEditorFactory.presentation.id"
    [attr.aria-disabled]="!templateEditorFactory.presentation.id"
    (click)="templateEditorFactory.copyPresentation()"
  >
    <mat-icon
      aria-hidden="true"
      class="template-editor-toolbar__menu-icon"
      svgIcon="duplicate"
    ></mat-icon>
    <span>Duplicate</span>
  </button>
  <button
    mat-menu-item
    role="menuitem"
    tabindex="-1"
    *requireRole="'!ap'"
    id="sharePresentationButton"
    [disabled]="!templateEditorFactory.presentation.id"
    [attr.aria-disabled]="!templateEditorFactory.presentation.id"
    (click)="openSettings()"
  >
    <mat-icon
      aria-hidden="true"
      class="template-editor-toolbar__menu-icon"
      svgIcon="presentations"
    ></mat-icon>
    <span>Save presentation as template</span>
  </button>
  @if (schedulesComponent) {
    <button
      mat-menu-item
      role="menuitem"
      tabindex="-1"
      id="schedules-edit"
      aria-label="Edit schedule settings for this presentation"
      (click)="editSchedules()"
    >
      <mat-icon
        aria-hidden="true"
        class="template-editor-toolbar__menu-icon"
        svgIcon="calendar"
      ></mat-icon>
      <span>Set Schedule</span>
    </button>
  }
  <button
    mat-menu-item
    role="menuitem"
    tabindex="-1"
    id="deleteButton"
    class="template-editor-toolbar__delete-menu-item"
    [disabled]="!templateEditorFactory.presentation.id"
    [attr.aria-disabled]="!templateEditorFactory.presentation.id"
    (click)="confirmDelete()"
  >
    <mat-icon
      aria-hidden="true"
      class="template-editor-toolbar__menu-icon"
      svgIcon="trash"
    ></mat-icon>
    <span>Delete</span>
  </button>
</ng-template>

<ng-template #publishChangeState let-icon="icon" let-tooltip="tooltip">
  <mat-icon
    class="publish-button__icon tw-h-[18px] tw-w-[18px]"
    [ngClass]="icon"
    [svgIcon]="icon"
    [matTooltip]="tooltip"
    matTooltipClass="menu-tooltip tw-max-w-[200px]"
    [attr.aria-label]="tooltip"
    tabindex="0"
    matTooltipPosition="below"
  />
</ng-template>

<ng-template #changeState let-icon="icon" let-tooltip="tooltip">
  <mat-icon
    class="tw-mr-[22px] medium"
    [ngClass]="icon"
    [svgIcon]="icon"
    [matTooltip]="tooltip"
    matTooltipClass="menu-tooltip tw-max-w-[200px]"
    [attr.aria-label]="tooltip"
    tabindex="0"
    matTooltipPosition="below"
  />
</ng-template>
